export const emailConfig = {
  senderEmail: 'info@vantaprints.com',
  senderName: 'VantaPrints'
};